import _ from 'lodash';
import {Config} from './types';

const config: Config = {
    RABBIT_URL: 'ws://127.0.0.1:15674/ws',
    RABBIT_LOGIN: 'guest',
    RABBIT_PASSWORD: 'guest',
    RABBIT_VIRTUAL_HOST: '/',
};

let customConfig = {};
try {
    customConfig = require('./config.custom.ts');
} catch(e) {
    console.warn('config.custom.ts not found, using default config');
}

export default _.extend(config, customConfig);
